module.exports = __webpack_public_path__ + "static/media/next.1b0c5d4e.svg";